(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () {
    /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
    const __meta__ = {
        id: "polifill",
        name: "Polifill",
        category: "web",
        description: "A polifill for kendo. Typically injected in messages and cultures.",
        depends: [ ],
    };

    if (!window.kendo) {
        console.error("kendo is not loaded.", "Ensure that kendo scripts are loaded before this script.");
    }

    (function( window, undefined$1 ) {
        kendo.cultures["sr-Latn-RS"] = {
            name: "sr-Latn-RS",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ".",
                ".": ",",
                groupSize: [3],
                percent: {
                    pattern: ["-n%","n%"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "Serbian Dinar",
                    abbr: "RSD",
                    pattern: ["-n $","n $"],
                    decimals: 0,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "RSD"
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["nedelja","ponedeljak","utorak","sreda","četvrtak","petak","subota"],
                        namesAbbr: ["ned","pon","uto","sre","čet","pet","sub"],
                        namesShort: ["ne","po","ut","sr","če","pe","su"]
                    },
                    months: {
                        names: ["januar","februar","mart","april","maj","jun","jul","avgust","septembar","oktobar","novembar","decembar"],
                        namesAbbr: ["jan","feb","mar","apr","maj","jun","jul","avg","sep","okt","nov","dec"]
                    },
                    AM: ["pre podne","pre podne","PRE PODNE"],
                    PM: ["po podne","po podne","PO PODNE"],
                    patterns: {
                        d: "d.M.yyyy.",
                        D: "dddd, dd. MMMM yyyy.",
                        F: "dddd, dd. MMMM yyyy. HH:mm:ss",
                        g: "d.M.yyyy. HH:mm",
                        G: "d.M.yyyy. HH:mm:ss",
                        m: "d. MMMM",
                        M: "d. MMMM",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "HH:mm",
                        T: "HH:mm:ss",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "MMMM yyyy.",
                        Y: "MMMM yyyy."
                    },
                    "/": ".",
                    ":": ":",
                    firstDay: 1
                }
            }
        };
    })();

}));
